import {
    TblCollectionDossierJsonldPanierunitaireRead,
    TblDossier2JsonldPanierunitaireRead,
    TblFacture2JsonldPanierunitaireRead,
} from '@europrocurement/l2d-domain/openApi/ApiFacturation';

export const sumCollections = (
    collectionsSelected: TblCollectionDossierJsonldPanierunitaireRead[],
) => collectionsSelected.reduce((acc, c) => acc + Number(c.acompteAttenduRestant ?? 0), 0);
export const sumFactures = (facturesSelected: TblFacture2JsonldPanierunitaireRead[]) =>
    facturesSelected.reduce((acc, f) => acc + Number(f.ttcRestant ?? 0), 0);
export const sumDossiers = (dossiersSelected: TblDossier2JsonldPanierunitaireRead[]) =>
    dossiersSelected.reduce((acc, d) => acc + Number(d.ttcRestant ?? 0), 0);

export const sumttcAPayer = (
    collectionsSelected: TblCollectionDossierJsonldPanierunitaireRead[] | undefined,
    facturesSelected: TblFacture2JsonldPanierunitaireRead[] | undefined,
    dossiersSelected: TblDossier2JsonldPanierunitaireRead[] | undefined,
) =>
    sumCollections(collectionsSelected ?? []) +
    sumFactures(facturesSelected ?? []) +
    sumDossiers(dossiersSelected ?? []);

export const getNbElementSelected = (
    collectionsSelected: TblCollectionDossierJsonldPanierunitaireRead[] | undefined,
    facturesSelected: TblFacture2JsonldPanierunitaireRead[] | undefined,
    dossiersSelected: TblDossier2JsonldPanierunitaireRead[] | undefined,
) =>
    (collectionsSelected ?? []).length +
    (facturesSelected ?? []).length +
    (dossiersSelected ?? []).length;
